<template>
	<component v-bind:is="iframeModal ? 'layout-blank' : 'layout-splash'">
		<div>
			<div
				class="bg-green px-6 py-4 lg:rounded-tl-2xl xl:rounded-t-2xl flex justify-start items-center"
			>
				<h1 class="text-4xl font-semibold text-white">{{ h1 }}</h1>

				<ui-button
					type="blank"
					class="absolute right-5 top-5"
					v-if="iframeModal"
					v-on:click="closeIframeModal()"
				>
					<ui-icon class="h-9 w-9 text-white" name="x" stroke-width="2" />
				</ui-button>
			</div>
			<div class="row">
				<div class="col-md-3 col-xl-3" />
				<div class="col-md-6 col-xl-5">
					<paper-bid
						:reference="reference"
						:active-futures="activeFutures"
						:trade="trade"
						:redirect="redirect"
					/>
				</div>
				<div class="col-md-3 col-xl-4" />
			</div>
		</div>
	</component>
</template>
<script>
let sampleOffers = require("../components/Paper/paper-sample-data.json");
let options = require("../cropOptions");

export default {
	props: {
		reference: {
			type: Object,
			required: true,
		},
		trade: {
			type: String,
			required: true,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
		iframeModal: {
			type: Boolean,
			default: false,
		},
		success: {
			type: Boolean,
			default: false,
		},
		redirect: {
			type: String,
			default: null,
		},
	},
	created() {},
	methods: {
		closeIframeModal() {
			if ("parentIFrame" in window) {
				parentIFrame.close();
			}
		},
	},
	computed: {
		h1() {
			if (this.trade == "BUY") {
				return this.__("Buy on paper market");
			} else {
				return this.__("Sell on paper market");
			}
		},
	},
	mounted() {
		// in case of iframe, signal to parent that we are mounted and ready to be displayed
		setTimeout(function () {
			if ("parentIFrame" in window) {
				window.parentIFrame.sendMessage("READY_TO_RUMBLE");
			}
		}, 300);
	},
};
</script>
